import {gql} from "@apollo/client"


export const USER_BUSINESS_QUERY = gql`
  query MyBusiness {
    myBusiness {
      uuid
      businessName
      subdomain
    }
  }
`

export const UNAUTHED_BUSSINESS_QUERY = gql`
  query MyBusinessByRemoteId($id: ID!) {
    businessByRemoteId(id: $id) {
      uuid
      businessName
      subdomain
    }
  }
`
